import React, { useMemo } from 'react';
import { GRADE_STUDENT_STATES } from 'utils/Constants';

import { Title } from 'components/Misc/Typography';
import { Button, Datepicker, Select } from 'components/Misc/Form';

import Payments from 'containers/Administrator/Users/Create/Student/Payments';
import Marks from 'containers/Administrator/Users/Create/Student/Marks';
import Warrants from 'containers/Administrator/Users/Create/Student/Warrants';
import Courses from 'containers/Administrator/Users/Create/Student/Courses';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Grade = ({ grade }) => {
	// Use user's creation store
	const [onChangeStudentGrade, onRemoveStudentGrade, onGenerateStudentPlan] = useUserCreateStore(state => [
		state.onChangeStudentGrade,
		state.onRemoveStudentGrade,
		state.onGenerateStudentPlan
	]);

	// Handle grade change for student
	const onChange = (change) => onChangeStudentGrade(grade.id, change);

	// Handle grade removal for student
	const onRemove = () => onRemoveStudentGrade(grade.id);

	// Handle grade plan generation
	const onGenerate = () => onGenerateStudentPlan(grade.id);

	// Check if generation is disabled
	const isDisabled = useMemo(() => {
		return !grade.startDate
			|| !grade.endDate
			|| !grade.courses?.length;	
	}, [grade]);

	return (
		<div className="py-3 px-4 border rounded-lg dark:border-neutral-700 grid md:grid-cols-2 gap-4">
			<div className="space-y-4">
				{/* Grade's information and control */}
				<div className="flex items-center space-x-2">
					<Title
						title={grade.title}
						subtitle={grade.program?.title}
						className="flex-1"
					/>

					{/* Grade removal if is in modal list */}
					<Button
						small
						square
						icon="close"
						theme="danger"
						onClick={onRemove}
					/>
				</div>

				{/* Student's grade state */}
				<div className="flex justify-start">
					<Select
						small
						name="state"
						label="Statuss"
						placeholder=" "
						value={grade.state}
						onChange={onChange}
						options={GRADE_STUDENT_STATES.map(state => ({
							value: state.value, name: state.text
						}))}
					/>
				</div>

				{/* Grade's start and end dates */}
				<div className="flex items-end space-x-2">
					<Datepicker
						name="startDate"
						label="Sākuma datums"
						value={grade.startDate}
						onChange={onChange}
					/>

					<Datepicker
						end
						name="endDate"
						label="Beigu datums"
						value={grade.endDate}
						onChange={onChange}
					/>

					<div className="flex-1 flex justify-end">
						<Button
							small
							square
							theme="success"
							icon="double_arrow"
							onClick={onGenerate}
							disabled={isDisabled}
						/>
					</div>
				</div>

				{/* Grade's payment plan */}
				<Payments grade={grade} isDisabled={isDisabled} />

				{/* Grade's additional marks */}
				<Marks grade={grade} />

				{/* Grade's warrants */}
				<Warrants grade={grade} />
			</div>

			{/* Grade's courses */}
			<Courses gradeId={grade.id} />
		</div>
	);
};

export default Grade;